/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FrontLoaderLabStation = {
    readonly id?: number;
    readonly lab_id?: number;
    type: FrontLoaderLabStation.type;
    name: string;
    readonly cassette_printer_id?: number;
    readonly clia_certificate_id?: number;
    description: string;
}

export namespace FrontLoaderLabStation {

    export enum type {
        RECEIVING = 'receiving',
        ACCESSIONING = 'accessioning',
        GROSSING = 'grossing',
        PROCESSING = 'processing',
        EMBEDDING = 'embedding',
        CUTTING = 'cutting',
        STAINING = 'staining',
        SCANNING = 'scanning',
        FRIDGE = 'fridge',
        SHIPPING = 'shipping',
        MANAGER = 'manager',
    }


}
